var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsPattern1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8411",
    "data-name": "Group 8411",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 420,
    height: 420,
    viewBox: "0 0 420 420",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2395",
    "data-name": "Rectangle 2395",
    width: 420,
    height: 420,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7512",
    "data-name": "Group 7512",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7511",
    "data-name": "Group 7511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7510",
    "data-name": "Group 7510",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7509",
    "data-name": "Group 7509",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7508",
    "data-name": "Group 7508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7507",
    "data-name": "Group 7507",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7241",
    "data-name": "Path 7241",
    d: "M88.242,158.846a70.607,70.607,0,1,1,70.606,70.609A70.606,70.606,0,0,1,88.242,158.846Z",
    transform: "translate(50.97 50.969)",
    fill: "none",
    stroke: "#638dff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7242",
    "data-name": "Path 7242",
    d: "M253.192,165.208A87.982,87.982,0,1,1,165.21,77.226,87.983,87.983,0,0,1,253.192,165.208Z",
    transform: "translate(44.608 44.607)",
    fill: "none",
    stroke: "#638dff",
    strokeMiterlimit: 10,
    strokeWidth: 1.345
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7243",
    "data-name": "Path 7243",
    d: "M276.928,171.569A105.357,105.357,0,1,1,171.57,66.213,105.359,105.359,0,0,1,276.928,171.569Z",
    transform: "translate(38.246 38.246)",
    fill: "none",
    stroke: "#638dff",
    strokeMiterlimit: 10,
    strokeWidth: 1.191
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7244",
    "data-name": "Path 7244",
    d: "M300.666,177.931A122.733,122.733,0,1,1,177.934,55.2,122.733,122.733,0,0,1,300.666,177.931Z",
    transform: "translate(31.884 31.884)",
    fill: "none",
    stroke: "#638dff",
    strokeMiterlimit: 10,
    strokeWidth: 1.036
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_171",
    "data-name": "Ellipse 171",
    cx: 140.109,
    cy: 140.109,
    r: 140.109,
    transform: "matrix(0.16, -0.987, 0.987, 0.16, 49.074, 325.673)",
    fill: "none",
    stroke: "#638dff",
    strokeMiterlimit: 10,
    strokeWidth: 0.881
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7245",
    "data-name": "Path 7245",
    d: "M348.139,190.654A157.483,157.483,0,1,1,190.655,33.172,157.484,157.484,0,0,1,348.139,190.654Z",
    transform: "translate(19.161 19.161)",
    fill: "none",
    stroke: "#638dff",
    strokeMiterlimit: 10,
    strokeWidth: 0.727
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7246",
    "data-name": "Path 7246",
    d: "M371.877,197.016A174.859,174.859,0,1,1,197.019,22.158,174.859,174.859,0,0,1,371.877,197.016Z",
    transform: "translate(12.799 12.799)",
    fill: "none",
    stroke: "#638dff",
    strokeMiterlimit: 10,
    strokeWidth: 0.572
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7247",
    "data-name": "Path 7247",
    d: "M395.613,203.378c0,106.169-86.065,192.237-192.234,192.237S11.145,309.547,11.145,203.378,97.21,11.144,203.379,11.144,395.613,97.209,395.613,203.378Z",
    transform: "translate(6.438 6.437)",
    fill: "none",
    stroke: "#638dff",
    strokeMiterlimit: 10,
    strokeWidth: 0.417
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7248",
    "data-name": "Path 7248",
    d: "M.131,209.739C.131,93.975,93.975.131,209.741.131S419.349,93.975,419.349,209.739,325.506,419.351,209.741,419.351.131,325.5.131,209.739Z",
    transform: "translate(0.076 0.076)",
    fill: "none",
    stroke: "#638dff",
    strokeMiterlimit: 10,
    strokeWidth: 0.263
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsPattern1);
export default __webpack_public_path__ + "static/media/dots-pattern1.c3508dbd19ba956c334bf7a61a6204ed.svg";
export { ForwardRef as ReactComponent };